<template lang="pug">
.dialog-container(v-if="show", @touchmove.prevent)
  .dialog-info
    .dialog-block
      img(:src="couponInfo.cyclePic[showIndex].pic")
    .dialog-sign(@click="goNext") {{couponInfo.cyclePic[showIndex].buttonText}}
  .shadow
  </template>
<script>
import { env } from '@hb/hbridge';
import { getVersion } from '@/utils/systemCode';

export default {
  components: {
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    couponInfo: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      env,
      version: '',
      blockList: [{ img: 'https://m.hellobike.com/resource/gallery/61/uDSuyzmy_Group%201707482312.png?x-oss-process=image/quality,q_80', btn: '开始体验' },
        { img: 'https://m.hellobike.com/resource/gallery/61/ahJq4duJ_Group%201707482311.png?x-oss-process=image/quality,q_80', btn: '知道了' },
      ],
      showIndex: 0,
    };
  },
  watch: {
  },
  async created() {
    this.version = await getVersion();
  },
  mounted() {
  },
  destroyed() {
  },
  methods: {
    goNext() {
      this.showIndex += 1;
      if (this.showIndex === this.couponInfo.cyclePic.length) {
        this.$emit('update:show', false);
      }
    },
  },
};
</script>

<style lang="less" scoped>
.dialog-container {
  .dialog-info {
    position: fixed;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -70%);
    z-index: 330;

    .dialog-close {
      display: flex;
      justify-content: flex-end;
      margin-bottom: 0.2rem;

      img {
        width: 0.26rem;
        height: 0.26rem;
      }
    }


    .dialog-block {
      width: 3.51rem;
      height: 3.61rem;
      img {
        width: 3.51rem;
        height: 3.61rem;
      }
    }

    .dialog-sign {
      width: 1.12rem;
      height: 0.36rem;
      background: #0080e9;
      color: #fff;
      margin: 0.64rem auto 0 auto;
      font-family: PingFangSC-Medium, PingFang SC, sans-serif;
      font-weight: 500;
      font-size: 0.14rem;
      line-height: 0.36rem;
      text-align: center;
      border-radius: 0.29rem;
    }
  }

  .shadow {
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.7);
    z-index: 300;
  }
}
</style>
